export const invLookupDataArray = [
    {
        label: 'Part Master',
        name: 'inscor__Part_Master__c',
        ordinal: -1,
        picklistValues: null,
        readOnly: false,
        referencesTo: 'Product2',
        required: true,
        tableName: 'sf_product2',
        type: 'customQuery',
        value: null,
        valueName: null,
    },
];
